import { render } from "./CustomOffer.vue?vue&type=template&id=99ac6378&scoped=true"
import script from "./CustomOffer.vue?vue&type=script&lang=js"
export * from "./CustomOffer.vue?vue&type=script&lang=js"

import "./CustomOffer.vue?vue&type=style&index=0&id=99ac6378&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99ac6378"]])

export default __exports__